import React from "react";
export const columns1 = (renderOperation = (text, record, index) => <a>查看</a>) => [
    {
        title: '序号',
        width: 70,
        dataIndex: 'index',
        key: 'index',
        fixed: 'left',
        render: (text, record, index)=>{
                return <div>{index+1}</div>
        }
    },
    {
        title: '申请人',
        width: 80,
        dataIndex: 'inquiryName',
        key: 'inquiryName',
    },
    // {
    //     title: '身份证号',
    //     dataIndex: 'inquiryCard',
    //     key: 'inquiryCard',
    //     width: 180,
    // },
    {
        title: '联系电话',
        dataIndex: 'inquiryTel',
        key: 'inquiryTel',
        width: 130,
    },
    {
        title: '公司名称',
        dataIndex: 'inquiryCompanyName',
        key: 'inquiryCompanyName',
        width: 150,
    },
    {
        title: '区县',
        dataIndex: 'chooseCounty',
        key: 'chooseCounty',
        width: 100,
    },
    {
        title: '公司地址',
        dataIndex: 'inquiryCompanyAddress',
        key: 'inquiryCompanyAddress',
        width: 200,
    },
    {
        title: '统一社会信用代码',
        dataIndex: 'socialCreditCode',
        key: 'socialCreditCode',
        width: 200,
    },
    {
        title: '巡诊申请时间',
        dataIndex: 'createTime',
        key: 'createTime',
        width: 170,
    },
    {
        title: '信息状态',
        dataIndex: 'inquiryMessageState',
        key: 'inquiryMessageState',
        fixed: 'right',
        width: 100,
        render: (text, record, index)=>{
            if(text=='1'){
                return <div>已回复</div>
            }else{
                return <div>未回复</div>
            }
        }
        
    },
    {
        title: '操作',
        key: 'operation',
        fixed: 'right',
        width: 100,
        render: renderOperation,
    },
];

export const columns2 = (renderOperation = (text, record, index) => <a>查看</a>) => [
    {
        title: '序号',
        width: 60,
        dataIndex: 'index',
        key: 'index',
        fixed: 'left',
        render: (text, record, index)=>{
                return <div>{index+1}</div>
        }
    },
    {
        title: '申请人',
        width: 80,
        dataIndex: 'inquiryName',
        key: 'inquiryName',
    },
    // {
    //     title: '身份证号',
    //     dataIndex: 'inquiryCard',
    //     key: 'inquiryCard',
    //     width: 180,
    // },
    {
        title: '联系电话',
        dataIndex: 'inquiryTel',
        key: 'inquiryTel',
        width: 150,
    },
    {
        title: '项目名称',
        dataIndex: 'inquiryProjectName',
        key: 'inquiryProjectName',
        width: 150,
    },
    {
        title: '区县',
        dataIndex: 'chooseCounty',
        key: 'chooseCounty',
        width: 100,
    },
    {
        title: '创业地址',
        dataIndex: 'entrepreneurshipAddress',
        key: 'entrepreneurshipAddress',
        width: 200,
    },
    {
        title: '巡诊申请时间',
        dataIndex: 'createTime',
        key: 'createTime',
        width: 150,
    },
    {
        title: '信息状态',
        dataIndex: 'inquiryMessageState',
        key: 'inquiryMessageState',
        fixed: 'right',
        width: 100,
        render: (text, record, index)=>{
            if(text=='1'){
                return <div>已回复</div>
            }else{
                return <div>未回复</div>
            }
        }
        
    },
    {
        title: '操作',
        key: 'operation',
        fixed: 'right',
        width: 80,
        render: renderOperation,
    },
];

export const data1 = [];
for (let i = 0; i < 20; i++) {
    data1.push({
        index: i + 1, proposer: '张三', id_number: 430482145321456321, contact_number: 13910733521, corporate_name: '某某科技公司', districts_counties: '南山区', company_address: '深圳市南山区粤海街道', unified_credit_code: 'AM465256799223217A', application_time: '2022.5.2 11:00', information_status: i % 2 == 0 ? '已回复' : '未回复'
    });
}

export const data2 = [];
for (let i = 0; i < 20; i++) {
    data2.push({
        index: i + 1, proposer: '张三', id_number: 430482145321456321, contact_number: 13910733521, project_name: '某某科技公司', districts_counties: '南山区', project_address: '深圳市南山区粤海街道', application_time: '2022.5.2 11:00', information_status: i % 2 == 0 ? '已回复' : '未回复'
    });
}
